/** Status-dot colors shared by the KPI tiles on all Partner Organizations tabs. */
export const KPI_TILE_COLORS = {
  blue: "#00AEEF",
  green: "rgba(0, 201, 80, 1)",
  orange: "rgba(255, 129, 3, 1)",
  red: "rgba(201, 23, 0, 1)",
};
